<template>
  <div class="search-input">
    <img class="search-input__icon" :src="icon" alt="" />
    <input :value="modelValue" @change="e => $emit('update:modelValue', e.target.value)" class="search-input__field" placeholder="Пошук..." name="search" />
  </div>
</template>

<script>
import icon from "@/assets/refactored_assets/img/form/eye_hidden.svg";
export default {
  name: "SearchInput",
  components: {},

  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],

  data() {
    return {
      icon: icon,
    };
  },
};
</script>

<style scoped lang="scss">


</style>
